export default [
  {
    path: '/late-reasons',
    name: 'late-reasons',
    component: () => import('@/views/late-reasons/LateReasons.vue'),
  },
]
